.titleBackground {
	background-color: var(--title-background);
}

.customMargin {
	margin-left: -40px !important;
	margin-bottom: 6px !important;
}

.marginTopFifteen {
	margin-top: 15px !important;
}

.warningBox {
	margin-top: 10px !important;
	text-align: left;
}
